import React, { useState, useEffect } from 'react';
import { Card, Table, DatePicker, Space, Button, Input, Tag } from 'antd';
import { activityLogService } from '../../services/activityLogService';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Search } = Input;

const ActivityStats = () => {
  const [loading, setLoading] = useState(false);
  const [activities, setActivities] = useState([]);
  const [dateRange, setDateRange] = useState([dayjs().startOf('month'), dayjs().endOf('month')]);
  const [searchText, setSearchText] = useState('');

  const fetchActivities = async () => {
    try {
      setLoading(true);
      const [startDate, endDate] = dateRange;
      
      const logs = await activityLogService.getActivityLogs({
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
      });

      setActivities(logs.map(log => ({
        key: log.id,
        user: log.get('user'),
        action: log.get('action'),
        details: log.get('details'),
        timestamp: log.get('timestamp'),
      })));
    } catch (error) {
      console.error('Error fetching activities:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivities();
  }, [dateRange]);

  const handleQuickSelect = (period) => {
    switch (period) {
      case 'today':
        setDateRange([dayjs().startOf('day'), dayjs().endOf('day')]);
        break;
      case 'week':
        setDateRange([dayjs().startOf('week'), dayjs().endOf('week')]);
        break;
      case 'month':
        setDateRange([dayjs().startOf('month'), dayjs().endOf('month')]);
        break;
      case 'year':
        setDateRange([dayjs().startOf('year'), dayjs().endOf('year')]);
        break;
    }
  };

  const getActionColor = (action) => {
    const actionColors = {
      '创建学员': 'blue',
      '更新学员信息': 'cyan',
      '申请退学': 'orange',
      '创建考试': 'green',
      '提交考试结果': 'purple',
      '创建支付记录': 'gold',
      '查询支付记录': 'lime',
      '审档通过': 'green',
      '审档不通过': 'red',
      default: 'default'
    };
    return actionColors[action] || actionColors.default;
  };

  const filteredActivities = activities.filter(activity => {
    const searchLower = searchText.toLowerCase();
    return (
      activity.user.toLowerCase().includes(searchLower) ||
      activity.action.toLowerCase().includes(searchLower) ||
      activity.details.toLowerCase().includes(searchLower)
    );
  });

  const columns = [
    {
      title: '时间',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (timestamp) => dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
    {
      title: '用户',
      dataIndex: 'user',
      key: 'user',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 150,
      render: (action) => (
        <Tag color={getActionColor(action)}>{action}</Tag>
      ),
    },
    {
      title: '详情',
      dataIndex: 'details',
      key: 'details',
      ellipsis: true,
    },
  ];

  return (
    <Card title="操作记录">
      <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
        <Space>
          <Button onClick={() => handleQuickSelect('today')}>今天</Button>
          <Button onClick={() => handleQuickSelect('week')}>本周</Button>
          <Button onClick={() => handleQuickSelect('month')}>本月</Button>
          <Button onClick={() => handleQuickSelect('year')}>今年</Button>
          <RangePicker
            value={dateRange}
            onChange={setDateRange}
            style={{ width: 300 }}
          />
        </Space>
        <Search
          placeholder="搜索用户、操作或详情"
          allowClear
          onChange={e => setSearchText(e.target.value)}
          style={{ width: 300 }}
        />
      </Space>
      <Table
        columns={columns}
        dataSource={filteredActivities}
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 条记录`,
        }}
      />
    </Card>
  );
};

export default ActivityStats; 